import { defineMessages } from 'react-intl'

const scope = `procurify.expense.features.SpendTrackerPresenter`

export default defineMessages({
  budgetTrackerHeader: {
    id: `${scope}.budgetTrackerHeader`,
    defaultMessage: 'Budgets',
  },
  spendTrackerHeader: {
    id: `${scope}.spendTrackerHeader`,
    defaultMessage: 'Spend tracker',
  },
})
